import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Heading, Text } from '@grandvisionhq/elements';

const StoreOptician = (_param)=>{
    var { name , details , imageUrl , fallbackImageUrl , className  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "name",
        "details",
        "imageUrl",
        "fallbackImageUrl",
        "className"
    ]);
    const sharedProps = {
        className: classnames('store-optician__image', {
            'store-optician__image--fallback': !imageUrl
        }),
        'data-t': 'ImageContainer'
    };
    return /*#__PURE__*/ React.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('store-optician', className)
    }), /*#__PURE__*/ React.createElement("div", swcHelpers.extends({}, sharedProps), /*#__PURE__*/ React.createElement("img", {
        src: imageUrl !== null && imageUrl !== void 0 ? imageUrl : fallbackImageUrl,
        "data-t": "Image",
        alt: name
    })), /*#__PURE__*/ React.createElement(Heading, {
        component: "h4",
        variant: "subheading1",
        className: "store-optician__name"
    }, name), details && /*#__PURE__*/ React.createElement(Text, {
        variant: "body",
        className: "store-optician__details"
    }, details));
};

export { StoreOptician as default };
//# sourceMappingURL=StoreOptician.js.map
